import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";

import Loader from "../../components/NewView/Common/Loader";
// const HomeComponent = React.lazy(() =>
//   import("../Components/RootComponents/HomeComponent")
// );

const HomeComponent = React.lazy(() =>
    import("../../components/NewView/RootComponents/HomeComponent")
  );
const HomePage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Loader />}>
        <Helmet>
          <title>Yellow Hub Харків | Робота, курси, консультації та МОЖУ</title>
          <meta
            name="description"
            content="Yellow Hub у Харкові допомагає з роботою, кар'єрними консультаціями, курсами, перекваліфікацією та програмою МОЖУ для професійного розвитку."
          />
          <meta
            name="keywords"
            content="Yellow Hub, YellowHub, Єловхаб, Єлов Хаб, Еллоу Хаб, Йеллоу Хаб, Еловхаб, робота Харків, вакансії Харків, допомога Харків, курси Харків, безкоштовні курси Харків, МОЖУ, можу Харків, програма МОЖУ, кар'єрний центр Харків, перекваліфікація Харків, кар'єрні консультації, курси для дорослих"
          />
          <link rel="canonical" href="https://yellowhub.com.ua/start" />
          <meta property="og:title" content="Yellow Hub Харків - робота, курси, консультації та МОЖУ" />
          <meta
            property="og:description"
            content="Кар'єрний центр Yellow Hub: робота, курси, консультації, перекваліфікація, програма МОЖУ та підтримка у працевлаштуванні."
          />
          <meta property="og:url" content="https://yellowhub.com.ua/start" />
          <meta property="og:type" content="website" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Yellow Hub Харків - кар'єрний центр" />
          <meta
            name="twitter:description"
            content="Робота, курси, консультації та програма МОЖУ для людей, які хочуть розвитку і стабільності."
          />
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              name: "Yellow Hub Харків",
              url: "https://yellowhub.com.ua/start",
              description:
                "Кар'єрний центр у Харкові: робота, курси, кар'єрні консультації, перекваліфікація та програма МОЖУ.",
              about: [
                "робота у Харкові",
                "курси у Харкові",
                "кар'єрні консультації",
                "перекваліфікація",
                "програма МОЖУ",
              ],
              isPartOf: {
                "@type": "WebSite",
                name: "Yellow Hub",
                url: "https://yellowhub.com.ua",
              },
            })}
          </script>
        </Helmet>
        <HomeComponent />
      </Suspense>
    </Fragment>
  );
};

export default HomePage;
